import React, { useState } from "react";

const WifiQrCode = ({ setQrData }) => {
    const [ssid, setSsid] = useState("");
    const [password, setPassword] = useState("");
    const [encryption, setEncryption] = useState("WPA");

    const handleSsidChange = (e) => {
        const value = e.target.value || e.target.placeholder;
        setSsid(value);
        updateQrData(value, password, encryption);
    };

    const handlePasswordChange = (e) => {
        const value = e.target.value || e.target.placeholder;
        setPassword(value);
        updateQrData(ssid, value, encryption);
    };

    const handleEncryptionChange = (e) => {
        setEncryption(e.target.value);
        updateQrData(ssid, password, e.target.value);
    };

    const updateQrData = (ssid, password, encryption) => {
        const qrData = `WIFI:T:${encryption};S:${ssid};P:${password};;`;
        setQrData(qrData);
    };

    return (
        <div className="wifi-qrcode">
            <div className="form-group">
                <label htmlFor="ssid">SSID</label>
                <input
                    type="text"
                    id="ssid"
                    value={ssid}
                    placeholder="Ex.: Minha Rede Wi-Fi"
                    onChange={handleSsidChange}
                />
            </div>
            <div className="form-group">
                <label htmlFor="password">Password</label>
                <input
                    type="text"
                    id="password"
                    value={password}
                    placeholder="Ex.: minhaSenha123"
                    onChange={handlePasswordChange}
                />
            </div>
            <div className="form-group">
                <label htmlFor="encryption">Encryption</label>
                <select
                    id="encryption"
                    value={encryption}
                    onChange={handleEncryptionChange}
                >
                    <option value="WPA">WPA/WPA2</option>
                    <option value="WEP">WEP</option>
                    <option value="nopass">No Password</option>
                </select>
            </div>
        </div>
    );
};

export default WifiQrCode;